import he from 'he';
import {
  requestViaBackendProxy,
  extractHaitangwMedia,
  buildMediaSourceResult
} from './musicPluginProxy.js';
import { buildKugouSearchUrl } from './kugouSignature.js';
import { enrichKgSearchCovers, resolveKgCoverFromItem, stripSearchHighlightTags } from './plazaCoverUtils.js';

const PAGE_SIZE = 30;
const PLATFORM = 'kg';
const AUDIO_PATH = 'kg_song_kw.php';

const QUALITY_LEVELS = {
  low: '128',
  standard: '128',
  high: '320',
  super: '320'
};

const SEARCH_HEADERS = {
  Referer: 'https://www.kugou.com/',
  'User-Agent':
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36'
};

const REQUEST_HEADERS = {
  Referer: 'https://www.kugou.com/',
  'User-Agent':
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36'
};

function normalizeSong(item) {
  if (!item) return null;

  const fileHash = item.FileHash || item.hash || item.HASH;
  if (!fileHash) return null;

  const singers = stripSearchHighlightTags(
    item.SingerName || item.singername || item.author_name || item.artist || '未知艺术家'
  );
  const cover = resolveKgCoverFromItem(item);

  return {
    id: fileHash,
    title: he.decode(
      stripSearchHighlightTags(
        item.SongName || item.songname || item.filename || item.name || '未知歌曲'
      )
    ),
    artist: he.decode(singers),
    album: he.decode(item.AlbumName || item.album_name || ''),
    albumId: item.AlbumID || item.album_id,
    albumAudioId: item.Audioid || item.album_audio_id,
    duration: Number(item.Duration || item.duration || 0),
    coverUrl: cover,
    artwork: cover,
    source: 'kg-plugin',
    raw: item
  };
}

async function search(query, page = 1) {
  if (!query?.trim()) {
    throw new Error('搜索关键词不能为空');
  }

  const url = buildKugouSearchUrl(query.trim(), page, PAGE_SIZE);
  const parsedBody = await requestViaBackendProxy(url, SEARCH_HEADERS);

  if (parsedBody?.error_code && parsedBody.error_code !== 0) {
    throw new Error(parsedBody.error_msg || `酷狗搜索失败(${parsedBody.error_code})`);
  }

  const songs = parsedBody?.data?.lists || parsedBody?.data?.list || [];
  const total = Number(parsedBody?.data?.total ?? songs.length);
  const data = songs.map(normalizeSong).filter(Boolean);
  await enrichKgSearchCovers(data);

  return {
    isEnd: page * PAGE_SIZE >= total || data.length < PAGE_SIZE,
    total,
    data
  };
}

async function getMediaSource(musicItem, quality = 'high') {
  const songId = musicItem?.id || musicItem?.raw?.FileHash || musicItem?.raw?.hash;
  if (!songId) {
    throw new Error('酷狗歌曲ID不能为空');
  }

  const qualityLevel = QUALITY_LEVELS[quality] || QUALITY_LEVELS.high;
  const audioUrl = `https://music.haitangw.cc/music/${AUDIO_PATH}?id=${songId}&quality=${qualityLevel}`;
  const responseData = await requestViaBackendProxy(audioUrl, REQUEST_HEADERS);
  const audioData = extractHaitangwMedia(responseData);
  return buildMediaSourceResult(audioData, musicItem, quality);
}

async function getLyric(musicItem, options = {}) {
  if (options.cachedLyric) {
    return options.cachedLyric;
  }
  return getMediaSource(musicItem, 'high').then((result) => {
    if (result.lyric) {
      return result.lyric;
    }
    throw new Error('无法获取酷狗歌词');
  });
}

const kgPluginClient = {
  platform: PLATFORM,
  version: '1.2.0',
  search,
  getMediaSource,
  getLyric
};

export default kgPluginClient;
